import { createSlice } from '@reduxjs/toolkit';

const initialState = {

  salesGroupList : [],
  docTypeList : [],
  TypeList : [],
  LoadingList:[]
};

const SlicePickingList = createSlice({
  name: "SlicePickingList",
  initialState,
  reducers: {
    setSalesGroupList(state, action) {
      state.salesGroupList = action.payload;
    },
    setDocTypeList(state, action) {
      state.docTypeList = action.payload;
    },
    setTypeList(state, action) {
      state.TypeList = action.payload;
    },
    setLoadingList(state, action) {
      state.LoadingList = action.payload;
    },
  },
});

export const {setSalesGroupList, setDocTypeList, setTypeList ,setLoadingList} = SlicePickingList.actions;
export default SlicePickingList.reducer;
